import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const carouselIndicatorFn = /* @__PURE__ */ createRecipe('carousel-indicator', {}, [])

const carouselIndicatorVariantMap = {
  "color": [
    "danger"
  ]
}

const carouselIndicatorVariantKeys = Object.keys(carouselIndicatorVariantMap)

export const carouselIndicator = /* @__PURE__ */ Object.assign(memo(carouselIndicatorFn.recipeFn), {
  __recipe__: true,
  __name__: 'carouselIndicator',
  __getCompoundVariantCss__: carouselIndicatorFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: carouselIndicatorVariantKeys,
  variantMap: carouselIndicatorVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, carouselIndicatorVariantKeys)
  },
  getVariantProps: carouselIndicatorFn.getVariantProps,
})